import { useRecordContext, useLocaleState } from "react-admin";
import PropTypes from "prop-types";
import moment from "moment";

import { SetLocale } from "./index.js";

const DateField = ({ source }) => {
  const record = useRecordContext();
  const [locale] = useLocaleState();

  SetLocale(locale);
  const value = record[source];
  const numValue = parseInt(value);
  const dateValue = Date.parse(value);

  if (!value) {
    return <span></span>;
  }

  if (isNaN(dateValue))
    return (
      <span>
        {record &&
          moment(numValue).calendar(null, {
            sameDay: "DD-MM-YYYY HH:mm:ss",
            nextDay: "DD-MM-YYYY HH:mm:ss",
            nextWeek: "DD-MM-YYYY HH:mm:ss",
            lastDay: "DD-MM-YYYY HH:mm:ss",
            lastWeek: "DD-MM-YYYY HH:mm:ss",
            sameElse: "DD-MM-YYYY HH:mm:ss",
          })}
      </span>
    );

  return (
    <span>
      {record &&
        moment(dateValue).calendar(null, {
          sameDay: "DD-MM-YYYY HH:mm:ss",
          nextDay: "DD-MM-YYYY HH:mm:ss",
          nextWeek: "DD-MM-YYYY HH:mm:ss",
          lastDay: "DD-MM-YYYY HH:mm:ss",
          lastWeek: "DD-MM-YYYY HH:mm:ss",
          sameElse: "DD-MM-YYYY HH:mm:ss",
        })}
    </span>
  );
};

DateField.propTypes = {
  source: PropTypes.string.isRequired,
};

export default DateField;
